<!-- Page Header Start -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content Start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <app-articles-view
    [articles]="prepArticlesArray"
    [itemsPerPage]="limit"
    [totalcount] ="totalcount"
    (onPaginateEvent) = "onPaginateEvent($event)"
  ></app-articles-view>
</div>
<!-- Page content End-->
